import Swal from 'sweetalert2';

// إعدادات SweetAlert الافتراضية
const defaultConfig = {
  customClass: {
    popup: 'swal-popup-custom',
    title: 'swal-title-custom',
    confirmButton: 'swal-confirm-btn',
    cancelButton: 'swal-cancel-btn'
  },
  buttonsStyling: false,
  allowOutsideClick: false,
  allowEscapeKey: true
};

// دالة لعرض رسالة نجاح
export const showSuccess = (title, text, timer = 2000) => {
  return Swal.fire({
    ...defaultConfig,
    title,
    text,
    icon: 'success',
    timer,
    showConfirmButton: false,
    background: '#fff',
    color: '#333',
    iconColor: '#68B977'
  });
};

// دالة لعرض رسالة خطأ
export const showError = (title, text, timer = 3000) => {
  return Swal.fire({
    ...defaultConfig,
    title,
    text,
    icon: 'error',
    timer,
    showConfirmButton: false,
    background: '#fff',
    color: '#333',
    iconColor: '#EF4444'
  });
};

// دالة لعرض تأكيد الحذف
export const showDeleteConfirmation = (title = 'Are you sure?', text = 'You won\'t be able to revert this!') => {
  return Swal.fire({
    ...defaultConfig,
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
    background: '#fff',
    color: '#333',
    iconColor: '#F59E0B'
  });
};

// دالة لعرض رسالة معلومات
export const showInfo = (title, text, timer = 3000) => {
  return Swal.fire({
    ...defaultConfig,
    title,
    text,
    icon: 'info',
    timer,
    showConfirmButton: false,
    background: '#fff',
    color: '#333',
    iconColor: '#5A6D8B'
  });
};

// دالة لعرض رسالة تحذير
export const showWarning = (title, text, timer = 3000) => {
  return Swal.fire({
    ...defaultConfig,
    title,
    text,
    icon: 'warning',
    timer,
    showConfirmButton: false,
    background: '#fff',
    color: '#333',
    iconColor: '#F59E0B'
  });
};

export default {
  showSuccess,
  showError,
  showDeleteConfirmation,
  showInfo,
  showWarning
}; 